import React from 'react'
import ce2020 from '../images/ce2020.jpg'
import logo1 from '../images/logo.png'
import Link from '../components/Link'
import { ReactTypeformEmbed } from 'react-typeform-embed'

const ChristianityExplored = () => {
  return (
    <div style={{ margin: '30px auto', maxWidth: '70ch' }}>
      <div style={{ textAlign: 'center' }}>
        <img className="logo" src={logo1} style={{ width: '400px' }} />
      </div>
      <div style={{ marginTop: '30px' }}>
        <img
          src={ce2020}
          style={{ display: 'block', borderRadius: '4px', width: '100%' }}
        />
        <p>
          Christianity Explored is a seven-week course for anyone interested in
          finding out more about the Christian faith. You can tune in online on
          Thursday at 8pm, starting Thursday 7th May.
        </p>
        <p>
          Together we'll watch a video, and then discuss it in question & answer
          format. No question is off limits - but equally you are welcome to
          just listen in.
        </p>
        <p>
          The evening will last one hour and will take place on Zoom, led by
          Tom.
        </p>
        <p>
          Just fill in the form below to let us know you'd like to join in. And
          if you've got more questions, do&nbsp;
          <Link to="mailto:jon@cornerstonechurchportsmouth.org">email Jon</Link>
          .
        </p>
        <h3>Register interest</h3>
        <p>
          Let us know if you'd like to join us here, and we will email you full
          details.
        </p>

        <div
          style={{ display: 'block', position: 'relative', height: '400px' }}
        >
          <ReactTypeformEmbed
            popup={false}
            url="https://nathan341.typeform.com/to/XuU7sj"
          />
        </div>
      </div>
    </div>
  )
}

export default ChristianityExplored



// WEBPACK FOOTER //
// ./src/pages/christianity-explored.js